import { render } from "./Preview.vue?vue&type=template&id=1cd5a2f4&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=1cd5a2f4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd5a2f4"]])

export default __exports__